import React from 'react';
import { ArrowUpRightIcon, DatabaseIcon, ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const CorePrintBlock: React.FC = () => {
  return <section className="w-full bg-white pb-20 md:pb-24" data-id="element-272" data-mp="3s8z0pd1oy3y1">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-273" data-mp="3s8fs4mxxkrwo">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#1F222C] rounded-2xl p-8 md:p-12" data-id="element-274" data-mp="11mkp1cjnwjp">
          <div className="flex flex-col lg:flex-row lg:items-center gap-8" data-id="element-275" data-mp="3ebahe9n9v4v3">
            <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-white/10 text-white flex-shrink-0" data-id="element-276" data-mp="17j9o76ogmu8i">
              <DatabaseIcon className="h-7 w-7" aria-hidden="true" data-id="element-277" data-mp="1cfqlaqdn0ixq" />
            </div>
            <div className="flex-grow max-w-2xl" data-id="element-278" data-mp="3d9h5t1xle0ry">
              <p className="text-white/60 text-sm font-semibold mb-2" data-id="element-279" data-mp="38cqrok5clf96">
                Voor wie verder wil groeien
              </p>
              <h2 className="text-white font-bold text-2xl md:text-3xl mb-3" data-id="element-280" data-mp="3m2c41bon6w88">
                CorePrint, onze methodiek voor structurele groei
              </h2>
              <p className="text-white/75 leading-relaxed" data-id="element-281" data-mp="2ubxshm43pvzq">
                Zit de basis op orde en wil je verder dan de eigen regio? Dan
                meten we eerst welke vraag er in jouw markt daadwerkelijk is,
                voordat we ergens in investeren. Een van onze zes diensten, geen
                startpunt.
              </p>
            </div>
            <a href="https://coreprint.nl/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-[#1F222C] font-semibold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-200 flex-shrink-0" data-id="element-282" data-mp="2yg5kpt9rpu2p">
              Lees over CorePrint
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-283" data-mp="3ce3h43y9azsc" />
            </a>
          </div>

          {/* Marktexclusiviteit hoort uitsluitend bij het Platinum-pakket,
              niet bij CorePrint in het algemeen en niet bij losse websites. */}
          <div className="mt-8 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-284" data-mp="2opake59t8nwo">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-white/10 text-white flex-shrink-0" data-id="element-285" data-mp="2sqmcqik2jn8k">
              <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-286" data-mp="2xpqjl2jit8vq" />
            </div>
            <div data-id="element-287" data-mp="32h8o20kr5rlg">
              <h3 className="text-white font-semibold text-lg mb-2" data-id="element-288" data-mp="32hqq5du3j01a">
                Marktexclusiviteit bij Platinum
              </h3>
              <p className="text-white/70 leading-relaxed text-sm max-w-3xl" data-id="element-289" data-mp="24z8lkfxnlxp6">
                Kies je voor het Platinum-pakket, dan werken we in jouw markt en
                regio niet ook voor je directe concurrent zolang het traject
                loopt. Bij de andere pakketten geldt die afspraak niet.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};